import { Card, Box } from '@mui/material';
import { ApiStatus } from '@constants';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { loadMemberDetails, selectMemberDetails } from '@redux/teams';
import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useIsPhone } from '@hooks';
import { belowAppBar } from '@theme/variables';
import {
  DynamicBreadcrumbs,
  MemberBreadcrumbsSkeleton,
  MemberInfoSkeleton,
  MemberProfile,
} from '@components';

export const MemberLayout = () => {
  const { teamId, memberId } = useParams();
  const dispatch = useAppDispatch();
  const memberDetails = useAppSelector(selectMemberDetails);
  const selectedAccountId = useAppSelector((state) => state.accounts.selected);
  const isPhone = useIsPhone();

  useEffect(() => {
    if (teamId && memberId) {
      dispatch(loadMemberDetails({ teamId, memberId }));
    }
  }, [teamId, memberId, dispatch, selectedAccountId]);

  if (memberDetails.apiStatus === ApiStatus.FORBIDDEN)
    return <>Access denied.</>;
  if (memberDetails.apiStatus === ApiStatus.FAILED)
    return <>Failed to load member.</>;

  const loading = memberDetails.apiStatus === ApiStatus.LOADING;
  const data = memberDetails.data;

  return (
    <Card
      sx={{
        padding: 2,
        margin: 2,
        overflow: 'visible',
        paddingTop: 0,
        ...(isPhone && { margin: 0, borderRadius: 0, boxShadow: 'none' }),
      }}
    >
      <Box
        sx={{
          position: 'sticky',
          top: belowAppBar('0px'),
          zIndex: 1,
          backgroundColor: 'background.paper',
          pt: 2,
          pb: 2,
          mx: { xs: -2, tablet: 0 },
          px: { xs: 2, tablet: 0 },
        }}
      >
        {loading || !data ? (
          <>
            <MemberBreadcrumbsSkeleton />
            <MemberInfoSkeleton />
          </>
        ) : (
          <>
            <DynamicBreadcrumbs data={data} />

            <MemberProfile memberDetails={data} />
          </>
        )}
      </Box>

      <Box mt={2}>
        <Outlet />
      </Box>
    </Card>
  );
};
